import type { RootState } from '@/redux';
import type { Challenge } from '@/services/api/types';
import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

export const state = { challenges: [] } as ChallengesState;

type ChallengesState = { challenges: Challenge[] };

export const {
  reducer,
  actions: { setChallengesData, setChallengeData }
} = createSlice({
  initialState: state,
  name: 'challenges',
  reducers: {
    setChallengesData: (_, action: PayloadAction<Challenge[]>) => ({
      challenges: action.payload
    }),

    setChallengeData: (state, action: PayloadAction<Challenge>) => ({
      challenges: state.challenges
        .filter(({ id }) => action.payload.id !== id)
        .concat(action.payload)
    })
  }
});

export const getChallenges = (state: RootState) => state.challenges.challenges;
